
'format es6';

import $ from 'jquery';

/**
 * Creates an instance of an accordeon (collapser).
 * 
 * @param {Number} i - Index in the loop
 * @param {*} node - DOMNode or jQuery Object 
 */
function Collapser(i, node) {
	const rootNode = $(node);
	const control = $('[data-expendable-control]', rootNode);
	const target = $('[data-expendable-target]', rootNode);

	/**
	 * Handles the click on the control button of the collapser.
	 * 
	 * @param {Event} e
	 */
	function toggleCollapse(e) {
		e.preventDefault();
		control.off('click.cursus');

		control.toggleClass('open');
		target.slideToggle(300, () => {
			target.toggleClass('open');

			control.on('click.cursus', toggleCollapse);
		});
	}

	control.on('click.cursus', toggleCollapse);
}

export default {
	/**
	 * Inits each collapser using the $.each loop.
	 */
	init() {
		$('[data-expendable]').each(Collapser);
	},
};
